import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useSearch } from "../context/SearchContext";
import { useUnit } from "../context/UnitContext";
import { useDefaultCity } from "../context/DefaultCityContext";

const SearchForm = ({ isInvalid, handleClearValidationError }) => {
  const defaultCity = useDefaultCity();
  const [city, setCity] = useState(defaultCity);
  const search = useSearch();
  const unit = useUnit();

  const handleLocationChange = (event) => {
    setCity(event.target.value);
    handleClearValidationError();
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    search(city, unit);
  };

  return (
    <Form onSubmit={handleSubmit}>
      <Row className="align-items-center">
        <Col xs={8} md={9}>
          <Form.Control
            placeholder="Location"
            autoFocus
            onChange={handleLocationChange}
          />
        </Col>
        <Col xs={4} md={3}>
          <Button type="submit" variant="primary" className="w-100">
            Search
          </Button>
        </Col>
        {isInvalid && (
          <div className="text-danger">There is no such destination.</div>
        )}
      </Row>
    </Form>
  );
};

export default SearchForm;
